var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"d-print-none"},[_vm._v(" Copyright © "+_vm._s(_vm.cYear())+" - Government of Saskatchewan: Drug Plan and Extended Benefits Branch ")])
}
var staticRenderFns = []

export { render, staticRenderFns }